<mat-dialog-content [@snFadeInDown]>
<form class="cjis-text-center">
    <sn-brand-logo  
    type="horizontal" 
    class="brand-logo" 
    size="md"
    [inverse]="true"
    >
  </sn-brand-logo>
    <main class="auth-p-sm">
      <h3 class="header">{{complianceTitle}}</h3>
      <ng-template [ngIf]="complianceMessage">
        <div [innerHTML]="complianceMessage"></div>
      </ng-template>
    </main>

    <mat-dialog-actions>
      <button mat-button color="success" (click)="aceptedCJIS()">{{ 'auth.cjisCompliance.agreeButton' | t }}</button>
      <button mat-button color="danger" (click)="logOut()">{{ 'common.close' | t }}</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
